export type CalculateTotalChargesOptions = {
  unitPrice?: number;
  vat?: number;
  quantity?: number;
  discount?: number;
};

export const calculateTotalCharges = (options: CalculateTotalChargesOptions): number => {
  const unitPrice = Math.max(Number(options?.unitPrice) || 0, 0);
  const vatPercent = Math.max(Number(options?.vat) || 0, 0);
  const quantity = Math.max(Number(options?.quantity) || 1, 1);
  const discountPercent = Math.max(Number(options?.discount) || 0, 0);

  const subtotal = unitPrice * quantity;

  // Discount — capped so it can’t exceed 100%
  const cappedDiscountPercent = Math.min(discountPercent, 100);
  const discountAmount = (subtotal * cappedDiscountPercent) / 100;

  const finalAmount = subtotal - discountAmount;

  const vatAmount = (finalAmount * vatPercent) / 100;

  const total = finalAmount + vatAmount;

  return Number(total.toFixed(2));
};
